var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',[_c('Resource')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }